module.exports = __webpack_public_path__ + "static/media/Card.70733108.svg";